import type { AuthUser, LoginResponse } from "@autoflow/types";
import { http } from "../../shared/api/http";

export const authApi = {
  login: async (input: { email:string; password:string }) =>
    (await http.post<LoginResponse>("/v1/auth/login", input)).data,
  logout: async (refreshToken: string) => {
    await http.post("/v1/auth/logout", { refreshToken });
  },
  me: async () => (await http.get<AuthUser>("/v1/auth/me")).data,
  changePassword: async (input: { currentPassword: string; newPassword: string }) => {
    await http.post("/v1/auth/password/change", input);
  }
};
